import moment from 'moment';
import useAxiosInterceptor from 'src/services/interceptor';
import {
  ASSIGN_THERAPIST_TASK,
  EDIT_TASK_TIME,
  GET_ALL_TASK_TYPE,
  GET_ALL_THERAPIST,
  GET_ALL_THERAPIST_DICIPLINE,
  GET_ALL_THERAPIST_TASK,
  GET_TASK_AVAILABILITY,
  MIGRATE_THERAPIST_PATIENT,
  MIGRATE_THERAPIST_TASK,
  REARRANGE_THERAPIST_TASK,
  THERAPIST_ASSIGN_DIALOG_TASK,
  UNASSIGN_THERAPIST_PATIENT,
  UNDO_THERAPIST_ASSIGNMENT,
} from '../constants';

class TherapistSchedulingServices {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getAllTherapistTask = (payload: any) => {
    const date = payload.data?.localDate;

    return this.axiosInstance.get(
      `${GET_ALL_THERAPIST_TASK(payload.data.providerId, payload.data.isV2)}?type=${
        payload.data.type
      }&active=${payload.data.active}&discipline=${
        payload.data.discipline
      }&localDate=${date}&skill=${payload.data.skill}&searchString=${encodeURIComponent(payload.data.searchString || '')}&page=${
        payload?.pageSize > 20 ? '0' : payload.pageNo
      }&pageSize=${payload?.pageSize ? payload?.pageSize : '20'}`,
      {
        signal: payload?.data?.signal,
      }
    );
  };

  getSkillListScheduling = (payload: any) => {
    return this.axiosInstance.get(`/provider/${payload?.therapistId}/scheduling/get-all-skills`);
  };

  getAllTaskType = (payload: any) => {
    return this.axiosInstance.get(
      `${GET_ALL_TASK_TYPE(payload.providerId)}?active=${payload.active}`
    );
  };

  getAllTherapistList = (payload: any) => {
    const forFilter = payload?.data?.forFilter || false;
    if (payload?.data?.filterByUuid)
      return this.axiosInstance.post(
        `${GET_ALL_THERAPIST(payload.data.providerId)}?localDate=${
          payload.data.localDate
        }&sortDirection=${payload.data.sortBy}&discipline=${payload.data.discipline}&page=${
          payload?.pageSize > 20 ? '0' : payload.pageNo
        }&pageSize=${payload?.pageSize ? payload?.pageSize : '20'}&searchString=${
          payload?.data?.searchData || ''
        }&forFilter=${forFilter}`,
        {
          filterByUuid: payload?.data?.filterByUuid,
        },
        {
          signal: payload?.data?.signal,
        }
      );
    else
      return this.axiosInstance.post(
        `${GET_ALL_THERAPIST(payload.data.providerId)}?localDate=${
          payload.data.localDate
        }&sortDirection=${payload.data.sortBy}&discipline=${payload.data.discipline}&page=${
          payload?.pageSize > 20 ? '0' : payload.pageNo
        }&pageSize=${payload?.pageSize ? payload?.pageSize : '20'}&searchString=${
          payload?.data?.searchData || ''
        }&forFilter=${forFilter}`,
        {},
        {
          signal: payload?.data?.signal,
        }
      );
  };

  AddTask = (payload: any) => {
    return this.axiosInstance.post(`provider/${payload.providerId}/scheduling`, payload.data);
  };

  therapistSchedulingTaskEdit = (payload: any) => {
    return this.axiosInstance.put(`provider/${payload.providerId}/scheduling`, payload.data);
  };

  getAllTherapistDiciplineList = (payload: any) => {
    return this.axiosInstance.get(
      `${GET_ALL_THERAPIST_DICIPLINE(
        payload.providerId,
        payload.data.isV2
      )}?localDate=${payload?.localDate}`
    );
  };

  therapistAssignTask = (payload: any) => {
    return this.axiosInstance.post(
      `${ASSIGN_THERAPIST_TASK(payload.providerId, payload.therapistId)}?assign-date=${
        payload.date
      }&discipline=${payload.meta.discipline}`,
      payload.data
    );
  };

  migrateTherapistAssignedTask = (payload: any) => {
    let url = `${MIGRATE_THERAPIST_TASK(
      payload.providerId
    )}?assignDate=${payload?.assignDate}&singleAssign=${payload?.singleAssign !== undefined ? payload.singleAssign : true}&sourceTherapist=${payload?.sourceTherapist}&targetTherapist=${payload?.targetTherapist}&taskId=${payload?.taskId}`;
    
    // Add appointment times if provided
    if (payload?.appointmentStartTime) {
      url += `&appointmentStartTime=${encodeURIComponent(payload.appointmentStartTime)}`;
    }
    if (payload?.appointmentEndTime) {
      url += `&appointmentEndTime=${encodeURIComponent(payload.appointmentEndTime)}`;
    }
    // Add new duration minutes if provided
    if (payload?.newDurationMinutes !== undefined && payload?.newDurationMinutes !== null) {
      url += `&newDurationMinutes=${encodeURIComponent(payload.newDurationMinutes)}`;
    }
    if (payload?.ignoreOverlap) {
      url += `&ignore-overlap=true`;
    }

    return this.axiosInstance.put(url);
  };

  migrateTherapistAssignedPatient = (payload: any) => {
    return this.axiosInstance.put(
      `${MIGRATE_THERAPIST_PATIENT(
        payload.providerId
      )}?assignDate=${payload?.assignDate}&sourceTherapist=${payload?.sourceTherapist}&targetTherapist=${payload?.targetTherapist}&patientId=${payload?.patientId}`
    );
  };

  undoTherapistAssignment = (payload: any) => {
    return this.axiosInstance.put(
      `${UNDO_THERAPIST_ASSIGNMENT(payload.providerId, payload.therapistId)}`,
      payload.requestBody
    );
  };

  unAssignTherapistPatient = (payload: any) => {
    return this.axiosInstance.put(
      `${UNASSIGN_THERAPIST_PATIENT(
        payload.providerId,
        payload.therapistId
      )}?assign-date=${payload?.currentDate}&patientId=${payload?.patientId}`
    );
  };

  rearrangeTherapistTask = (payload: any) => {
    return this.axiosInstance.post(
      `${REARRANGE_THERAPIST_TASK(payload.providerId)}?discipline=${payload.dicipline}`,
      payload.data
    );
  };

  editTaskTime = (payload: any) => {
    return this.axiosInstance.put(
      `${EDIT_TASK_TIME(payload.providerId)}?time=${payload.time}`,
      payload.requestBody
    );
  };

  getTaskAvailability = (payload: any) => {
    return this.axiosInstance.get(GET_TASK_AVAILABILITY(payload.providerId), {
      params: {
        patientId: payload.patientId,
        localDate: payload.localDate,
        discipline: payload.discipline,
      },
    });
  };

  therapistDialogAssignTask = (payload: any) => {
    return this.axiosInstance.post(
      `${THERAPIST_ASSIGN_DIALOG_TASK(payload.providerId, payload.therapistId)}?assign-date=${
        payload.date
      }`,
      payload.data
    );
  };

  getSchedulePrintPDFUrl = (providerUUID: string, dateString: string, sortOrder?: string) => {
    return this.axiosInstance.get(
      `/provider/${providerUUID}/scheduling/${providerUUID}/schedule-print/${dateString}`,
      {
        params: {
          sortOrder,
        },
      }
    );
  };

  getBulkPrintPDFUrl = (providerUUID: string, dateString: string, discipline?: string) => {
    return this.axiosInstance.get(
      `/provider/${providerUUID}/scheduling/therapists/bulk-print/${dateString}`,
      discipline ? { params: { discipline } } : undefined
    );
  };

  maintainTherapistFilter = (payload: any) => {
    return this.axiosInstance.put(`provider/therapist-filter/${payload.therapistId}`, {
      discipline: payload?.discipline,
      providerIds: payload?.therapists,
    });
  };

  getAllMaintainedTherapists = (payload: any) => {
    return this.axiosInstance.get(
      `provider/therapist-filter/${payload.therapistId}?discipline=${payload?.discipline}`
    );
  };

  updateTimeBasis = (payload: any) => {
    return this.axiosInstance.put(`/provider/v2/${payload?.providerId}/scheduling/time-basis`, {
      basis: payload?.basis,
    });
  };

  getSplitTaskMin = (payload: any) => {
    return this.axiosInstance.put(`provider/${payload.providerId}/scheduling/split`, null, {
      params: payload?.data,
    });
  };

  editSplitTaskMin = (payload: any) => {
    return this.axiosInstance.put(
      `provider/${payload.providerId}/scheduling/update-split-task`,
      null,
      {
        params: payload?.data,
      }
    );
  };

  getSplitTask = (payload: any) => {
    return this.axiosInstance.get(
      `provider/${payload.therapistId}/scheduling/get-split-task/${payload?.taskUuid}`
    );
  };

  deleteSplitTaskMin = (payload: any) => {
    return this.axiosInstance.delete(
      `provider/${payload.therapistId}/scheduling/delete-split-task`,
      {
        params: {
          taskUuid: payload?.taskUuid,
        },
      }
    );
  };

  getAppointmentSlots = (payload: any) => {
    return this.axiosInstance.get(
      `/provider/appointment/all?therapistUuid=${payload.therapistUuid}&discipline=${payload.discipline}&localDate=${payload.localDate}`
    );
  };

  scheduleAppointment = (payload: any) => {
    // Use the verify endpoint with VerifyTaskRequest structure
    const requestBody: any = {
      wantToGroup: false,
      unprocessedData: [payload.patientUuid],
      processedData: [],
      groupUuid: null,
      appointmentStartTime: payload.appointmentStartTime,
      appointmentEndTime: payload.appointmentEndTime,
    };

    // Only include newDurationMinutes when isAppointmentBook is true
    if (payload.isAppointmentBook) {
      requestBody.newDurationMinutes = payload.newDurationMinutes;
    }

    const ignoreOverlapParam = payload?.ignoreOverlap ? '&ignore-overlap=true' : '';
    return this.axiosInstance.post(
      `${ASSIGN_THERAPIST_TASK(payload.providerId, payload.therapistUuid)}?assign-date=${payload.assignDate}&discipline=${payload.discipline}${ignoreOverlapParam}`,
      requestBody
    );
  };

  getPatientTimeSlots = (payload: any) => {
    return this.axiosInstance.get(
      `/provider/appointment/time-slots?patientId=${payload.patientId}&taskDate=${payload.taskDate}`
    );
  };

  scheduleRecurringAppointment = (payload: any) => {
    return this.axiosInstance.post(`/provider/appointment/recurring`, payload);
  };

  updateRecurringSeries = (payload: any) => {
    const { recurringAppointmentUuid, startDate, appointmentStartTime, appointmentEndTime, newDurationMinutes } = payload;
    let url = `/provider/appointment/recurring-series/${recurringAppointmentUuid}?startDate=${startDate}`;
    
    if (appointmentStartTime) {
      url += `&appointmentStartTime=${encodeURIComponent(appointmentStartTime)}`;
    }
    if (appointmentEndTime) {
      url += `&appointmentEndTime=${encodeURIComponent(appointmentEndTime)}`;
    }
    if (newDurationMinutes !== undefined && newDurationMinutes !== null) {
      url += `&newDurationMinutes=${encodeURIComponent(newDurationMinutes)}`;
    }
    
    return this.axiosInstance.put(url);
  };

  cancelRecurringSeries = (payload: any) => {
    const { recurringAppointmentUuid, startDate } = payload;
    const url = `/provider/appointment/recurring-series/${recurringAppointmentUuid}/cancel?startDate=${startDate}`;
    return this.axiosInstance.delete(url);
  };

  getRecurringAppointmentCount = (payload: any) => {
    const { therapistUuid, discipline, daysOfWeek, startDate, endDate, appointmentStartTime, appointmentEndTime } = payload;
    let url = `/provider/appointment/recurring/count?therapistUuid=${therapistUuid}&discipline=${discipline}&daysOfWeek=${daysOfWeek}&startDate=${startDate}&endDate=${endDate}`;
    
    if (appointmentStartTime) {
      url += `&appointmentStartTime=${encodeURIComponent(appointmentStartTime)}`;
    }
    if (appointmentEndTime) {
      url += `&appointmentEndTime=${encodeURIComponent(appointmentEndTime)}`;
    }
    
    return this.axiosInstance.get(url);
  };
}

const therapistSchedulingServices = new TherapistSchedulingServices();

Object.freeze(therapistSchedulingServices);

export default therapistSchedulingServices;
